import globalAxios from "../GlobalAxios";

const listApi = async () => {
  try {
    const res = await globalAxios.get('/api/template/list');
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const previewApi = async (id) => {
  try {
    const res = await globalAxios.get(`/api/template/preview/${id}`);
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const deleteApi = async (data) => {
  try {
    const res = await globalAxios.delete('/api/template/delete', { data });
    return res.data;
  } catch (error) {
    console.error("error", error);
  }
}

const addApi = async (data) => {
  try {
    const res = await globalAxios.post('/api/template/create', data);
    return res;
  } catch (error) {
    console.error("error", error);
  }
}

const downloadApi = async (data) => {
  try {
    const res = await globalAxios.post(`/api/template/download`, data, 'blob',
    );
    return res;
  } catch (error) {
    console.error("error", error);
  }
}




export default {
  listApi,
  deleteApi,
  addApi,
  previewApi,
  downloadApi
};